import { useQuery } from "@apollo/client";

import { GET_WORK_SESSIONS } from "graphql/query/attendance-gql";


const useAttendanceSession = (eeId) => {
    const { data, loading, error, refetch } = useQuery(GET_WORK_SESSIONS, {
        variables: {
            where: {
                column: "EE_ID",
                operator: "EQ",
                value: eeId
            },
            orderBy: [
                {
                    column: "CHECK_IN_AT",
                    order: "DESC"
                }
            ],
            first: 1
        },
        skip: !eeId,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    });

    const currentSession = data?.workSessionsCursor?.edges?.[0]?.node || null;

    return {
        currentSession,
        isCheckedIn: Boolean(currentSession?.check_in_at && !currentSession?.check_out_at),
        loading: loading && !data,
        error,
        refetch
    };
};

export default useAttendanceSession;
